import { useState, useRef, KeyboardEvent } from "react";
import { UseTagInputProps } from "../types/tag-input-types";

export const useTagInput = ({
  value = [],
  onChange,
  disabled = false,
}: UseTagInputProps) => {
  const [inputValue, setInputValue] = useState("");
  const [isFocused, setIsFocused] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      e.preventDefault();
      addTag();
    } else if (e.key === "Backspace" && inputValue === "" && value.length > 0) {
      removeTag(value.length - 1);
    }
  };

  const addTag = () => {
    const trimmedInput = inputValue.trim();
    if (trimmedInput && !value.includes(trimmedInput)) {
      onChange?.([...value, trimmedInput]);
      setInputValue("");
    }
  };

  const removeTag = (index: number) => {
    if (disabled) return;
    const newTags = [...value];
    newTags.splice(index, 1);
    onChange?.(newTags);
  };

  const handleContainerClick = () => {
    if (!disabled && inputRef.current) {
      inputRef.current.focus();
    }
  };

  return {
    inputValue,
    isFocused,
    setIsFocused,
    inputRef,
    handleInputChange,
    handleKeyDown,
    removeTag,
    handleContainerClick,
  };
};
